import { CHANGE_THEME } from "../types";

export const initialState = {
  darkmode: false,
};

export const uiReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case CHANGE_THEME:
      return {
        ...state,
        darkmode: !state.darkmode,
      };

    default:
      return state;
  }
};
